import React from "react";

/**
 * Layout container for portal theme pages (no settings sidebar).
 * Plain `<div>` so we don't inherit any flex/grid sizing from MUI v7's
 * `<Grid />` or `<Box />` defaults — was rendering very narrow on the
 * customer portal because an ancestor Grid item was shrink-fitting it.
 */
export default function PortalThemeShell({ children }) {
  return (
    <div
      style={{
        display: "block",
        width: "100%",
        maxWidth: 900,
        marginLeft: "auto",
        marginRight: "auto",
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 24,
        paddingBottom: 24,
        boxSizing: "border-box",
      }}
    >
      {children}
    </div>
  );
}
